import type { ActionButtonConfig, DialogWrapperProps } from '@brightdrop/bd-ui';

export enum TableFilterDisplayMode {
  MODAL = 0,
  POPOVER = 1,
}

export type TableFilterProps<FilterSet> = Omit<
  DialogWrapperProps<FilterSet>,
  'onCloseModal' | 'openModal' | 'onResult'
> & {
  saveFilterOptions: (options: Partial<FilterSet>) => void;
  defaultState: FilterSet;
  onModalOpenUpdate: (isOpen: boolean) => void;
  id: string;
  modalOpen?: boolean;
  filterCount?: number;
  permanentFilters?: (keyof FilterSet)[];
  displayMode?: TableFilterDisplayMode;
  renderCustomButton?: (
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void,
    filterCount?: number
  ) => React.ReactNode;
  actionButtonsConfigOverride?: ActionButtonConfig[];
  extendedMobile?: boolean;
  customPopoverMaxHeight?: string | 'none';
  useSpaceBetweenButtons?: boolean;
  stableAnchor?: boolean;
};
